import { Injectable } from '@angular/core';
import { SPINNER_EUMS } from 'src/app/shared/enums/spinner-emuns';

@Injectable({
  providedIn: 'root'
})
export class Spinner {
  spinner: any;
  showCounter: number;
  hideCounter: number;
  constructor() {
    this.showCounter = 0;
    this.hideCounter = 0;
    this.spinner = document.getElementsByTagName(SPINNER_EUMS.APP_SPINNER)[0];
  }

  show() {
    this.lazyInitSpinner();
    this.showCounter++;
    this.spinner.classList.remove(SPINNER_EUMS.UNDISPLAY);
  }
  
  hide() {
    this.lazyInitSpinner();
    this.hideCounter++;
    if (this.showCounter > this.hideCounter) {
      return;
    }
    if (this.showCounter == this.hideCounter) {
      this.spinner.classList.add(SPINNER_EUMS.UNDISPLAY);
    }
  }

  lazyInitSpinner() {
    if (!this.spinner) {
      this.spinner = document.getElementsByTagName(SPINNER_EUMS.APP_SPINNER)[0];
    }
  }

}
